import { useFormik } from 'formik';
import * as Yup from 'yup';
import { CorporateAccountOpenProfileDetailsPages, useCorporateAccountOpenProfileDetailsPageTypeStore } from 'views/pages/accountOpenProfileDetails/corporateProfileDetails/hooks';
import { useEffect } from 'react';
import { useCorporateAccountEstablishStore } from '../hooks';
import { ErrorWord, TemplateProps, yupNumberString } from '../common';
import { formErrorScroll } from 'views/mutual/formErrorScroll';

export type ContactInfoType = {
  contactPhoneNumber: string;
  contactConfirmPhoneNumber: string; // リクエストに不要
  contactFaxNumber: string;
};

export const useContactInfo = ({ isUpdate }: TemplateProps) => {
  const { param, add } = useCorporateAccountEstablishStore();
  const { setAccountOpenProfileDetailsPageType } = useCorporateAccountOpenProfileDetailsPageTypeStore();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const validation = Yup.object().shape({
    contactPhoneNumber: Yup.string()
      .required(ErrorWord.PHONE)
      .matches(/^[0-9]{10,11}$/gi, ErrorWord.PHONE),
    contactConfirmPhoneNumber: Yup.string()
      .required(ErrorWord.HOME_PHONE_CONFIRM)
      .oneOf([Yup.ref('contactPhoneNumber')], ErrorWord.HOME_PHONE_CONFIRM),
    contactFaxNumber: yupNumberString({ length: 10, isRequired: false, errorWord: ErrorWord.FAX_PHONE }),
  });

  const initialValues: ContactInfoType = {
    contactPhoneNumber: param.contactPhoneNumber ?? '',
    contactConfirmPhoneNumber: param.contactConfirmPhoneNumber ?? '',
    contactFaxNumber: param.contactFaxNumber ?? '',
  };

  const formik = useFormik<ContactInfoType>({
    enableReinitialize: isUpdate,
    initialValues,
    async onSubmit() {
      add({
        ...param,
        ...formik.values,
      });

      if (param.dealerQuestion) {
        setAccountOpenProfileDetailsPageType(CorporateAccountOpenProfileDetailsPages.dealerInfo);
      } else {
        setAccountOpenProfileDetailsPageType(CorporateAccountOpenProfileDetailsPages.representInfo);
      }
    },
    validationSchema: validation,
    validateOnChange: false,
    validateOnBlur: false,
  });

  const contactPhoneNumberProps = {
    value: formik.values.contactPhoneNumber,
    onChange: (value: string) => formik.setFieldValue('contactPhoneNumber', value),
    error: formik.errors.contactPhoneNumber,
  };

  const contactConfirmPhoneNumberProps = {
    value: formik.values.contactConfirmPhoneNumber,
    onChange: (value: string) => formik.setFieldValue('contactConfirmPhoneNumber', value),
    error: formik.errors.contactConfirmPhoneNumber,
  };

  const contactFaxNumberProps = {
    value: formik.values.contactFaxNumber,
    onChange: (value: string) => formik.setFieldValue('contactFaxNumber', value),
    error: formik.errors.contactFaxNumber,
  };

  useEffect(() => {
    formErrorScroll();
  }, [formik.isSubmitting]);

  return {
    formik,
    contactPhoneNumberProps,
    contactConfirmPhoneNumberProps,
    contactFaxNumberProps,
  };
};
